import React, {useState, useEffect, useRef} from 'react';
import {useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Dropdown} from "primereact/dropdown";
import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";
import axios from "axios";
import currencyFormatter from "currency-formatter";

const ProjectstockListComponent = (props) => {

  const {t} = props;
  const {id} = useParams();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [inventoryDocumentDialogVisible, setInventoryDocumentDialogVisible] = useState(false);
  const [inventoryDocuments, setInventoryDocuments] = useState([]);
  const [inventoryDocumentsLoading, setInventoryDocumentsLoading] = useState(false);
  const [selectedInventoryDocument, setSelectedInventoryDocument] = useState(null);
  const [confirmInventoryDocumentDialogVisible, setConfirmInventoryDocumentDialogVisible] = useState(false);
  const [addingItemsToInventoryDocument, setAddingItemsToInventoryDocument] = useState(false);
  const [inventoryDocumentStatuses, setInventoryDocumentStatuses] = useState([]);
  const [inventoryDocumentTypes, setInventoryDocumentTypes] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }

  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }

  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }

  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          <Dropdown
            value={options.value}
            options={dropdownOptions}
            onChange={(e) => setRows(e.target.value)}
            appendTo={document.body}
          />
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
          {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data, params = {}) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params,
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

//   const actionBodyTemplate = (rowData) => {
//     return (
//       <React.Fragment>
//         {localStorage.getItem('roles').toString().includes('role_') &&
//           <Button icon="pi pi-pencil" className="p-button-warning p-mr-2"
//                   tooltip={t('edit')} tooltipOptions={{position: 'left'}}
//                   onClick={() => {
//                     if (entity === 'project-stock') {
//                       history.push('/inventory/project-stock/update/' + rowData.id)
//                     }
//                   }}/>
//         }
//         {localStorage.getItem('roles').toString().includes('role_') &&
//           <Button icon="pi pi-trash" className="p-button-danger"
//                   tooltip={t('delete')} tooltipOptions={{position: 'left'}}
//                   onClick={() => {
//                     if (window.confirm('A törlés megerősítésére van szükség!')) {
//                       setLoading(true);
//                       apiCall('delete', '/api/v2/inventory/project-stock/' + rowData.id)
//                         .then(response => {
//                           window.App.toastShow('success', 'Sikeres törlés!');
//                           window.App.setState({rerenderProjectstockList: Math.random()})
//                         })
//                         .catch(error => {
//                           window.App.toastShow('error', t('error'), error.toString(), '', error.response);
//                         })
//                         .finally(() => {
//                           setLoading(false);
//                         })
//                     }
//                   }}
//           />
//         }
//       </React.Fragment>
//     );
//   }

  const loadInventoryDocumentStatuses = () => {
    apiCall('get', '/api/v2/dictionary/inventory-document-status', {})
      .then(response => {
        setInventoryDocumentStatuses(response.data?.data || []);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
  };

  const loadInventoryDocumentTypes = () => {
    apiCall('get', '/api/v2/dictionary/inventory-document-type', {})
      .then(response => {
        setInventoryDocumentTypes(response.data?.data || []);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
  };

  const getInventoryDocumentTypeLabel = (typeKey) => {
    const type = (inventoryDocumentTypes || []).find(item => item.key === typeKey);
    return type ? type.value : typeKey;
  };

  const getInventoryDocumentStatusLabel = (statusKey) => {
    const status = (inventoryDocumentStatuses || []).find(item => item.key === statusKey);
    return status ? status.value : statusKey;
  };

  const loadDraftInventoryDocuments = () => {
    setInventoryDocumentsLoading(true);
    apiCall('get', '/api/v2/inventory-document?search[status][operator]==&search[status][value]=DRAFT', {})
      .then(response => {
        setInventoryDocuments(response.data?.data?.items || []);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setInventoryDocumentsLoading(false);
      });
  };

  const openInventoryDocumentBrowser = () => {
    if (!selectedItems || selectedItems.length === 0) {
      return;
    }
    setSelectedInventoryDocument(null);
    setInventoryDocumentDialogVisible(true);
    loadDraftInventoryDocuments();
    loadInventoryDocumentStatuses();
    loadInventoryDocumentTypes();
  };

  const getInventoryDocumentType = (inventoryDocument) => {
    return (
      inventoryDocument?.type || ''
    );
  };

  // const addSelectedStockItemsToInventoryDocument = () => {
  //   if (!selectedInventoryDocument) {
  //     return;
  //   }
  //   const type = getInventoryDocumentType(selectedInventoryDocument);
  //   if (!type) {
  //     window.App.toastShow('error', 'Hiba', 'Nem található a raktárjegy típusa.');
  //     return;
  //   }
  //   setAddingItemsToInventoryDocument(true);
  //   const payload = {
  //     inventory_document: selectedInventoryDocument.id,
  //     items: selectedItems.map(item => ({
  //       inventory: item.id,
  //       material: item.material?.id || item.material_id || null,
  //       warehouse_location: item.warehouse_location?.id || item.warehouse_location_id || null,
  //       quantity: Number(item.quantity - item.quantity_reserved),
  //       unit: item.unit?.id || item.unit_id || null,
  //       currency: item.currency || null,
  //       unit_cost: item.average_unit_cost || 0,
  //     }))
  //   };
  //   apiCall('post', '/api/v2/inventory-document-item/' + type, payload)
  //     .then(response => {
  //       window.App.toastShow('success', 'Sikeres hozzárendelés!', response.data?.message || '')
  //       setConfirmInventoryDocumentDialogVisible(false);
  //       setInventoryDocumentDialogVisible(false);
  //       setSelectedInventoryDocument(null);
  //       setSelectedItems([]);
  //       if (typeof props.onSelectionChange === 'function') {
  //         props.onSelectionChange([]);
  //       }
  //       window.App.setState({rerenderProjectstockList: Math.random()});
  //     })
  //     .catch(error => {
  //       window.App.toastShow('error', t('error'), error.toString(), '', error.response);
  //     })
  //     .finally(() => {
  //       setAddingItemsToInventoryDocument(false);
  //     });
  // };

  const addSelectedStockItemsToInventoryDocument = async () => {
    if (!selectedInventoryDocument) {
      return;
    }
    if (!selectedItems || selectedItems.length === 0) {
      return;
    }
    setAddingItemsToInventoryDocument(true);
    try {
      await Promise.all(
        selectedItems.map((item) =>
          apiCall('post', '/api/v2/inventory-document-item/transfer-supplier', {
            inventory_document: selectedInventoryDocument.id,
            material: item.material?.id || item.material_id || null,
            quantity: Number(item.quantity - (item.quantity_reserved || 0)),
          })
        )
      );
      window.App.toastShow('success', 'Sikeres hozzárendelés!');
      setConfirmInventoryDocumentDialogVisible(false);
      setInventoryDocumentDialogVisible(false);
      setSelectedInventoryDocument(null);
      setSelectedItems([]);
      if (typeof props.onSelectionChange === 'function') {
        props.onSelectionChange([]);
      }
      window.App.setState({
        rerenderProjectstockList: Math.random()
      });
      window.location.hash =
        `/inventory/inventory-document/update/${selectedInventoryDocument.id}?view=delivery_note&return=${encodeURIComponent('/project/project/read/' + id)}`;
    } catch (error) {
      window.App.toastShow('error', t('error'), error.toString(), '', error.response);
    } finally {
      setAddingItemsToInventoryDocument(false);
    }
  };

  useEffect(() => {
    if (typeof props.onRegisterAddToDeliveryNoteHandler === 'function') {
      props.onRegisterAddToDeliveryNoteHandler(openInventoryDocumentBrowser);
    }
  }, [selectedItems]);

  useEffect(() => {
    if (!id) return;

    setLoading(true);
    apiCall('get', '/api/v2/project/' + id, {})
      .then(response => {
        setProject(response.data.data);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setLoading(false);
      })
  }, [id]);

  useEffect(() => {
    if (!project) return;

    const warehouseId =
      project.warehouse_id !== undefined && project.warehouse_id !== null
        ? project.warehouse_id
        : (project.warehouse && project.warehouse.id
            ? project.warehouse.id
            : null);

    if (warehouseId === null) {
      return;
    }

    setLoading(true);

    const baseQuery = window.App.transformQueryParams(lazyParams);

    const extraFilter =
      '&search[warehouse][operator]=='
      + '&search[warehouse][value]=' + warehouseId;

    apiCall('get', '/api/v2/inventory' + baseQuery + extraFilter, {})
      .then(response => {
        setTotalRecords(response.data.data.total_item_count);
        setItems(response.data.data.items || []);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setLoading(false);
      })

  }, [project, lazyParams, window.App.state.rerenderProjectstockList]);

  const warehouseIdRender =
    project && (
      project.warehouse_id !== undefined && project.warehouse_id !== null
        ? project.warehouse_id
        : (project.warehouse && project.warehouse.id
            ? project.warehouse.id
            : null)
    );

  if (project && (warehouseIdRender === null || warehouseIdRender === undefined)) {
    return (
      <>
        <p className="p-m-3">{t('noProjectWarehouse')}</p>
      </>
    );
  }

  return (
    <>
      <Dialog
        visible={inventoryDocumentDialogVisible}
        style={{width: '1100px'}}
        header="Nyitott raktárjegyek tallózása"
        modal
        onHide={() => {
          setInventoryDocumentDialogVisible(false);
          setSelectedInventoryDocument(null);
        }}
      >
        <DataTable
          value={inventoryDocuments}
          loading={inventoryDocumentsLoading}
          emptyMessage={t('noOpenWarehouseTicket')}
          responsiveLayout="scroll"
          stripedRows
          dataKey="id"
        >
          <Column field="document_number" header={t('columnDocumentNumber2')} sortable />
          <Column field="type" header={t('columnType')} sortable body={(rowData) => getInventoryDocumentTypeLabel(getInventoryDocumentType(rowData))}/>
          <Column field="status" header={t('columnStatus2')} sortable body={(rowData) => getInventoryDocumentStatusLabel(rowData.status)} />
          <Column field="created_at" header={t('columnCreatedAt')} sortable
            body={(rowData) => (
              <>
                {rowData.created_at
                  ? window.App.formatDateValue(rowData.created_at)
                  : ''}
              </>
            )}
          />
          <Column header="" className="p-text-right p-text-nowrap"
            body={(rowData) => (
              <Button
                type="button"
                label="Kiválasztás"
                icon="pi pi-check"
                className="p-button-success p-button-sm"
                onClick={() => {
                  setSelectedInventoryDocument(rowData);
                  setConfirmInventoryDocumentDialogVisible(true);
                }}
              />
            )}
          />
        </DataTable>
      </Dialog>
      <Dialog
        visible={confirmInventoryDocumentDialogVisible}
        style={{width: '600px'}}
        header="Megerősítés"
        modal
        onHide={() => {
          if (!addingItemsToInventoryDocument) {
            setConfirmInventoryDocumentDialogVisible(false);
          }
        }}
      >
        <p>
          Biztosan hozzárendeled a {selectedItems?.length || 0} kijelölt tételt&nbsp;
          <strong>{selectedInventoryDocument?.document_number}</strong> bizonylathoz?
        </p>
        <div className="p-text-right p-mt-4">
          <Button
            type="button"
            label="Mégse"
            className="p-button-secondary"
            disabled={addingItemsToInventoryDocument}
            onClick={() => {
              setConfirmInventoryDocumentDialogVisible(false);
            }}
          />

          <Button
            type="button"
            label={props.t('yesAssign')}
            icon="pi pi-check"
            className="p-button-success p-ml-2"
            loading={addingItemsToInventoryDocument}
            onClick={addSelectedStockItemsToInventoryDocument}
          />
        </div>
      </Dialog>



      <DataTable
        size={localStorage.getItem('scale')}
        value={items}
        paginator
        first={lazyParams.first}
        totalRecords={totalRecords}
        onPage={onPage}
        onSort={onSort}
        sortField={lazyParams.sortField}
        sortOrder={lazyParams.sortOrder}
        onFilter={onFilter}
        filters={lazyParams.filters}
        loading={loading}
        lazy
        paginatorTemplate={pager}
        rows={rows}
        emptyMessage={t('noResults')}
        autoLayout={true}
        filterDisplay="row"
        responsiveLayout="scroll"
        stripedRows
        ref={dt}
        dataKey="id"
        selection={selectedItems}
        onSelectionChange={(e) => {
          setSelectedItems(e.value);
          if (typeof props.onSelectionChange === 'function') {
            props.onSelectionChange(e.value);
          }
        }}
        selectionMode="checkbox"
      >
        <Column selectionMode="multiple" headerStyle={{width: '3em'}} />
        <Column field="material.manufacturer.name" header={t('columnManufacturer')} sortable filter></Column>
        <Column field="material.name" header={t('columnProduct')} sortable filter></Column>
        <Column field="warehouse_location.code" header={t('columnWarehouseLocation')} sortable filter></Column>

        <Column
          field="quantity"
          header={t('columnStock')}
          sortable
          filter
          className={"p-text-right"}
          body={(rowData) => <>{Number(rowData.quantity)}</>}
        ></Column>

        <Column
          field="quantity_reserved"
          header={t('columnReservedStock')}
          sortable
          filter
          className={"p-text-right"}
          body={(rowData) => <>{Number(rowData.quantity_reserved)}</>}
        ></Column>

        <Column
          header={t('columnAvailableStock')}
          sortable
          filter
          className={"p-text-right"}
          body={(rowData) => <>{Number(rowData.quantity - rowData.quantity_reserved)}</>}
        ></Column>

        <Column field="unit.name" header={t('columnUnit')} sortable filter></Column>

        <Column
          field="material.avg_purchase_price"
          header={t('columnAveragePurchasePrice')}
          sortable
          filter
          className={"p-text-right"}
          body={(rowData) => {
            if (rowData.material?.avg_purchase_price == null) return '—';
            let currency = {
              precision: 2,
              symbol: '',
              decimal: ',',
              thousand: ' ',
            }
            return (
              <>
                {currencyFormatter.format(
                  rowData.material?.avg_purchase_price,
                  {
                    precision: currency.precision,
                    symbol: currency.symbol,
                    decimal: currency.decimal,
                    thousand: currency.thousand,
                  }
                )}&nbsp;HUF
              </>
            )
          }}
        ></Column>

        <Column
          field="last_movement_date"
          header={t('columnLastMovement')}
          sortable
          body={(rowData) => (
            <>{window.App.formatDateValue(rowData.last_movement_date)}</>
          )}
        ></Column>
      </DataTable>
    </>
  )
}

export default withTranslation('common')(ProjectstockListComponent);
